export const USER_TYPES = {
  SYSTEM: "system",
  TENANT: "tenant",
};

export const DEFAULT_PAGE_SIZE = 20;

export const USER_TYPE_LABELS = {
  [USER_TYPES.SYSTEM]: "System Users",
  [USER_TYPES.TENANT]: "Tenant Users",
};

export const USER_TYPE_SUBTITLES = {
  [USER_TYPES.SYSTEM]:
    "Search system users, then view details or create a new user.",
  [USER_TYPES.TENANT]:
    "Search tenant users by name, email, mobile, or user ID. Results appear after search.",
};
